export default {
  SIM_ONLY_PLUS: `singtel:all-mobile-deals/phone-eligible-for-installment-and-sim-only-plan`,
  IPP_OPTIONS: 'singtel:instalment-options/ipp-phones'
};
